
$( document ).ready(function() {

 /* SLIDING LINKS */

$('a[href^="#"]').click(function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top - 80},'slow');
});
  
/* MOVE STICKY CTA*/
setTimeout(() => {
  var stickyCTA = $('.zrx-sticky-atc-bar').detach();
  stickyCTA.appendTo('.transition-body');
}, "2000");
  
/* PARALAX IMAGES */
  $(".animated .feature-row__images").addClass("parallax");

  $(window).on("load scroll", function() {
    var parallaxElement = $(".parallax"),
      parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
          windowTop = $(window).scrollTop(),
          elementTop = currentElement.offset().top,
          elementHeight = currentElement.height(),
          viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
          scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * 0.2 + "px, 0) rotate(" + scrolled * 0.01 + "deg)"
        });
      }
    });
  });
  
});


/* HELP CENTER LINK URLS */
$( 'a[href="/pages/help-center"]' ).each(function( index ) {
  if(subdomain == "fi"){
    var hc = $(this).attr("href") + "?hcUrl=%2Ffi-fi";
    
    $(this).attr("href", hc);
  }
});



// Function to add a product variant to the Shopify AJAX cart
function addToCart(variantId, quantity = 1) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity
        })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Product added to cart:', data);
        // You can add code here to update the cart UI or notify the user
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

    })
    .catch((error) => {
        console.error('Error adding product to cart:', error);
    });
}

// Function to handle the click event on the <a> element
function handleAddToCart(event, variantId) {
    event.preventDefault(); // Prevent the default link behavior
    addToCart(variantId);
}


/* CART RECOMMENDATIONS */
$(document).ready(function() {
    function fetchAndDisplayRecommendations() {
        $.getJSON('/cart.js', function(cart) {
          
            if (cart.items.length > 0) {
                var firstProductId = cart.items[cart.items.length - 1].product_id;

  
                // Fetch recommendations
                $.ajax({
                    url: `/recommendations/products.json?product_id=${firstProductId}&limit=1&intent=complementary`,
                    method: 'GET',
                    success: function(data) {
                        if (data.products.length > 0) {
                            renderRecommendations(data.products);
                            showUpsellSlider();
                            console.log("SHOWING RECOMMENDATIONS...");
                        }
                    },
                    error: function() {
                        console.error('Failed to load recommendations');
                        
                    }
                });
            }
        });
    }

    function renderRecommendations(products) {
        var upsellContainer = $('#upsell-slider .upsell-products');
        upsellContainer.empty(); // Clear previous recommendations

        products.forEach(function(product) {
            var variantOptions = '';

            if (product.variants.length > 1) {
                variantOptions = `
                    <select class="variant-select" data-product-id="${product.id}">
                        ${product.variants.map(variant => `
                            <option value="${variant.id}">${variante.titolo} - ${(variant.price / 100).toFixed(2).replace('.', ',')} €</option>
                        `).join('')}
                    </select>
                `;
            }

            var productHtml = `
                <div class="upsell-product" id="upsell-product-${product.id}">
                    <a href="${product.url}">
                        <img src="${product.featured_image}" alt="${product.title}">
                    </a>
                    <div class="details">
                        <p>${product.title}</p>
                        ${variantOptions}
                        <button class="add-to-cart-btn" data-product-id="${product.variants[0].id}">Aggiungi</button>
                    </div>
                    <span>${(prodotto.prezzo / 100).toFixed(2).replace('.', ',')} €</span>
                </div>
            `;
            upsellContainer.append(productHtml);
        });

        // Update button data-product-id when a new variant is selected
        $('.variant-select').on('change', function() {
            var selectedVariantId = $(this).val();
            var productId = $(this).data('product-id');
            $(`#upsell-product-${productId} .add-to-cart-btn`).data('product-id', selectedVariantId);
        });

        // Attach click event to each "Add to Cart" button
        $('.add-to-cart-btn').on('click', function(event) {
            var variantId = $(this).data('product-id');
            handleAddToCart(event, variantId);

            // Hide the specific upsell product after it's added to the cart
            console.log()
            $(this).parent().parent().fadeOut(300, function() {
                $(this).remove(); // Remove the element after fading out
            });

            // If there are no more upsell products, hide the upsell slider
            if ($('#upsell-slider .upsell-product').length === 1) {
                hideUpsellSlider();
            }
        });
    }

    function showUpsellSlider() {
        $('#upsell-slider').fadeIn(300);
    }

    function hideUpsellSlider() {
        $('#upsell-slider').fadeOut(300);
    }



    // Initial check to load recommendations when the cart drawer is opened
    fetchAndDisplayRecommendations();

    // Re-fetch recommendations whenever the cart is updated
    
    $(document).on('cart:updated ajaxProduct:added', function() {
        fetchAndDisplayRecommendations();
        console.log("CART CHANGED...");
    });
    
});


</a>